import React, { useCallback } from "react";
import { APP_IMAGES } from "../../constants/images";
import { useTranslation } from "react-i18next";
import { Menu } from "lucide-react";
import { cn } from "../../utils/cn";
import ProfileDropdown from "../dropdown/ProfileDropdown";
import useAuthStore from "../../store/Auth";
import SwitchLanguageCard from "../card/SwitchLanguageCard";
import { useNavigate } from "react-router-dom";
import { USER_ROLES_IDS } from "../../constants/common";
import { APP_ROUTES } from "../../routes";

interface NavbarProps {
  onMenuClick: () => void;
  isSidebarOpen: boolean;
}

const Navbar = ({ onMenuClick, isSidebarOpen }: NavbarProps) => {
  const { t } = useTranslation();

  const { user } = useAuthStore();

  const navigate = useNavigate();

  const handleNavigation = useCallback(() => {
    if (
      user?.n_RoleID === USER_ROLES_IDS.ADMIN ||
      user?.n_RoleID === USER_ROLES_IDS.SECURITY ||
      user?.n_RoleID === USER_ROLES_IDS.SECURITY_MANAGER ||
      user?.n_RoleID === USER_ROLES_IDS.RECEPTION
    ) {
      navigate(APP_ROUTES.HOME);
    } else {
      navigate(APP_ROUTES.APPROVE_VISIT_REQUEST);
    }
  }, [navigate, user?.n_RoleID]);

  return (
    <nav className="w-full bg-white">
      <div
        className={cn(
          "py-2 px-[35px] flex items-center justify-between ",
          !isSidebarOpen && "2xl:px-0 2xl:max-w-[75vw] mx-auto"
        )}
      >
        <div className="flex items-center gap-1 sm:gap-3">
          {!isSidebarOpen && (
            <div>
              <Menu
                className="cursor-pointer w-3 sm:w-auto"
                onClick={onMenuClick}
                color="#000"
              />
            </div>
          )}
          <div className="w-[5rem] md:w-[7rem] lg:w-[10rem] cursor-pointer">
            <img onClick={handleNavigation} src={APP_IMAGES.logo} alt="logo" />
          </div>
        </div>

        <div className="flex items-center gap-1 sm:gap-3 md:gap-6">
          <p className="text-[10px] sm:text-lg font-medium tracking-wide capitalize whitespace-nowrap">
            {t("hello")}
            <br className="sm:hidden" /> {user?.firstname} {user?.lastname}!
          </p>

          <ProfileDropdown />
          <SwitchLanguageCard />
        </div>
      </div>
    </nav>
  );
};

export default React.memo(Navbar);
